import { Signal, inject } from '@angular/core';
import { ToSignalOptions, toObservable, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { Observable, map, switchMap } from 'rxjs';

export function signalAsync<S, O>(signal: Signal<S>, observable: (value: S) => Observable<O>, options: ToSignalOptions<any> = {}) {
  return toSignal(toObservable(signal, options).pipe(switchMap(value => observable(value))), options as any) as Signal<O>;
}

export type RouteParams = Record<string, string | undefined>;

export function getRouteParams(route: ActivatedRoute): RouteParams {
  let params = route.snapshot.params;
  let parent = route.parent;
  while (parent) {
    params = { ...parent.snapshot.params, ...params };
    parent = parent.parent;
  }
  return params;
}

export function injectRouteParams() {
  const route = inject(ActivatedRoute);
  const params = getRouteParams(route);
  return toSignal(route.params.pipe(map(() => getRouteParams(route))), { initialValue: params });
}

export function injectRouteParam(key: string) {
  const route = inject(ActivatedRoute);
  const params = getRouteParams(route);
  return toSignal(route.params.pipe(map(() => getRouteParams(route)[key])), { initialValue: params[key] });
}
